var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8289 23.1532H1.65539C0.743145 23.1532 0 22.4101 0 21.4978V1.65096C0 0.738715 0.743145 1.98812e-05 1.65539 1.98812e-05H26.8289C27.7367 -0.00443009 28.4798 0.738715 28.4798 1.65096V21.4978C28.4798 22.4101 27.7367 23.1532 26.8289 23.1532ZM2.06479 21.0884H26.415V2.06036H2.06479V21.0884Z",
    fill: "#32B3D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4477 7.39584H1.03264C0.463041 7.39584 0.000244141 6.93305 0.000244141 6.36345C0.000244141 5.79385 0.463041 5.33105 1.03264 5.33105H27.4477C28.0173 5.33105 28.4801 5.79385 28.4801 6.36345C28.4801 6.93305 28.0173 7.39584 27.4477 7.39584Z",
    fill: "#32B3D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01661 4.72592H4.57927C4.00967 4.72592 3.54688 4.26312 3.54688 3.69353C3.54688 3.12393 4.00967 2.66113 4.57927 2.66113H6.01661C6.58621 2.66113 7.049 3.12393 7.049 3.69353C7.049 4.26312 6.58621 4.72592 6.01661 4.72592Z",
    fill: "#32B3D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.e9dc4d8d7a5a494c6e9b3fef4584f93a.svg";
export { ForwardRef as ReactComponent };